"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Procedure = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../constants");

var _procedureModule = _interopRequireDefault(require("./procedure.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Procedure = function Procedure(_ref) {
  var tour = _ref.tour,
      pois = _ref.pois,
      user = _ref.user;
  var startWaypoint = tour.wayPoints && tour.wayPoints.find(function (waypoint) {
    return waypoint.type === _constants.WAYPOINT_TYPES.START;
  });
  var endWaypoint = tour.wayPoints && tour.wayPoints.find(function (waypoint) {
    return waypoint.type === _constants.WAYPOINT_TYPES.END;
  });
  var intermediateWaypoints = tour.wayPoints && tour.wayPoints.filter(function (waypoint) {
    return waypoint.type === _constants.WAYPOINT_TYPES.INTERMEDIATE;
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _procedureModule["default"].wrapper
  }, startWaypoint ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _procedureModule["default"].container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _procedureModule["default"].number
  }, 1), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bold"
  }, pois.find(function (poi) {
    return poi.id === startWaypoint.poiId;
  }) ? pois.find(function (poi) {
    return poi.id === startWaypoint.poiId;
  }).name : startWaypoint.poiName), startWaypoint.poiTriggerCondition && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: _constants.TRIGGER_CONDITION_START_TRANSLATIONS[startWaypoint.poiTriggerCondition],
    tagName: "span"
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: _procedureModule["default"].container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _procedureModule["default"].number
  }, 1), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourStart",
    tagName: "span"
  }), ":", ' ', /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: tour.scheduledStartTime,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  })))), intermediateWaypoints.map(function (waypoint, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: waypoint.id,
      className: _procedureModule["default"].container
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _procedureModule["default"].number
    }, index + 2), /*#__PURE__*/_react["default"].createElement("div", {
      className: "bold"
    }, pois.find(function (poi) {
      return poi.id === waypoint.poiId;
    }) ? pois.find(function (poi) {
      return poi.id === waypoint.poiId;
    }).name : waypoint.poiName), waypoint.plannedStopDuration && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.plannedStopDuration",
      tagName: "span"
    }), ":", ' ', /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.hoursAndMinutes",
      values: {
        hours: (0, _constants.splitDuration)(Math.abs(waypoint.plannedStopDuration)).hours,
        minutes: (0, _constants.splitDuration)(Math.abs(waypoint.plannedStopDuration)).minutes
      }
    })), waypoint.scheduledTimeOfArrival && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.scheduledTimeOfArrival",
      tagName: "span"
    }), ":", ' ', /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
      value: waypoint.scheduledTimeOfArrival,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      timeZone: user.timezone
    }))));
  }), endWaypoint ? /*#__PURE__*/_react["default"].createElement("div", {
    key: endWaypoint.id,
    className: _procedureModule["default"].container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _procedureModule["default"].number
  }, intermediateWaypoints.length + 2), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bold"
  }, pois.find(function (poi) {
    return poi.id === endWaypoint.poiId;
  }) ? pois.find(function (poi) {
    return poi.id === endWaypoint.poiId;
  }).name : endWaypoint.poiName), endWaypoint.scheduledTimeOfArrival && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.scheduledTimeOfArrival",
    tagName: "span"
  }), ":", ' ', /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: endWaypoint.scheduledTimeOfArrival,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  }))), endWaypoint.poiTriggerCondition && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: _constants.TRIGGER_CONDITION_END_TRANSLATIONS[endWaypoint.poiTriggerCondition],
    tagName: "span"
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: _procedureModule["default"].container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _procedureModule["default"].number
  }, intermediateWaypoints.length + 2), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourEnd",
    tagName: "span"
  }), ":", ' ', /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: tour.scheduledEndTime,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  })))));
};

exports.Procedure = Procedure;
Procedure.propTypes = {
  tour: _propTypes["default"].shape({
    scheduledStartTime: _propTypes["default"].string,
    scheduledEndTime: _propTypes["default"].string,
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }).isRequired,
  pois: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number.isRequired,
    name: _propTypes["default"].string.isRequired
  })).isRequired,
  user: _propTypes["default"].shape({
    timezone: _propTypes["default"].string
  }).isRequired
};
Procedure.defaultProps = {};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.rail'])(Procedure);

exports["default"] = _default;